export type WheelPaletteId =
  | "rainbow"
  | "classroom"
  | "pastel"
  | "team"
  | "custom";

export interface WheelPaletteOption {
  id: WheelPaletteId;
  label: string;
  colors?: string[];
}

export const WHEEL_PALETTES: WheelPaletteOption[] = [
  { id: "rainbow", label: "Rainbow" },
  {
    id: "classroom",
    label: "Classroom",
    colors: ["#0077BB", "#EE7733", "#33BBEE", "#EE3377", "#009988", "#F0E442"],
  },
  {
    id: "pastel",
    label: "Pastel",
    colors: [
      "#FFADAD",
      "#FFD6A5",
      "#FDFFB6",
      "#CAFFBF",
      "#9BF6FF",
      "#A0C4FF",
      "#BDB2FF",
      "#FFC6FF",
    ],
  },
  {
    id: "team",
    label: "Team colors",
    colors: ["#1D4ED8", "#DC2626", "#16A34A", "#FACC15"],
  },
  { id: "custom", label: "Custom" },
];

export const DEFAULT_CUSTOM_WHEEL_COLORS = [
  "#4A90E2",
  "#E94E77",
  "#F5A623",
  "#7ED321",
];

export const isWheelPaletteId = (value: string): value is WheelPaletteId => {
  return WHEEL_PALETTES.some((palette) => palette.id === value);
};

export const getWheelSliceFill = (
  index: number,
  totalSlices: number,
  paletteId: WheelPaletteId,
  customColors: string[],
): string => {
  if (paletteId === "rainbow") {
    const hue = totalSlices > 0 ? (index * 360) / totalSlices : 0;
    return `hsl(${hue}, 70%, 70%)`;
  }

  const palette = WHEEL_PALETTES.find((option) => option.id === paletteId);
  const colors =
    paletteId === "custom"
      ? customColors.filter((color) => /^#([0-9a-fA-F]{6})$/.test(color))
      : palette?.colors ?? [];

  if (colors.length === 0) {
    const hue = totalSlices > 0 ? (index * 360) / totalSlices : 0;
    return `hsl(${hue}, 70%, 70%)`;
  }

  return colors[index % colors.length];
};

export const getWheelSliceTextColor = (fill: string): string => {
  if (fill.startsWith("hsl")) {
    return "#000000";
  }

  const hex = fill.replace("#", "");
  if (hex.length !== 6) {
    return "#000000";
  }

  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "#000000" : "#FFFFFF";
};
